import { displayMatchTypes } from '@/common/components/MatchTypeEditor/constants'
import { isEmptyValue } from '@/common/components/MatchTypeEditor/helpers'

import { incompleteBoundLabel, singleValueLabelPrefixes, singleValueMatchTypeToConfigKey } from './constants'

export const getSingleValueFilterName = (config, matchType) => config[singleValueMatchTypeToConfigKey[matchType]]

export const getAmountMatchType = (filters, config) => {
  if (!isEmptyValue(filters[config.eq])) return displayMatchTypes.is
  if (!isEmptyValue(filters[config.gt])) return displayMatchTypes.greaterThan
  if (!isEmptyValue(filters[config.lt])) return displayMatchTypes.lowerThan
  if (!isEmptyValue(filters[config.gte]) || !isEmptyValue(filters[config.lte])) return displayMatchTypes.valueInRange

  return null
}

export const getAmountParamsForMatchType = (filters, config, matchType) => {
  if (matchType === displayMatchTypes.valueInRange) {
    return { [config.gte]: filters[config.gte] ?? null, [config.lte]: filters[config.lte] ?? null }
  }

  const filterName = getSingleValueFilterName(config, matchType)

  if (!filterName) return {}

  return { [filterName]: filters[filterName] ?? null }
}

export const getValueForMatchType = (value, config, matchType) => {
  if (matchType === displayMatchTypes.valueInRange) {
    return { min_value: value[config.gte], max_value: value[config.lte] }
  }

  return value[getSingleValueFilterName(config, matchType)]
}

export const buildAmountUpdate = (config, matchType, newValue) => {
  if (matchType === displayMatchTypes.valueInRange) {
    return { [config.gte]: newValue.min_value, [config.lte]: newValue.max_value }
  }

  return { [getSingleValueFilterName(config, matchType)]: newValue }
}

export const getAmountFilterLabel = (filters, config) => {
  const matchType = getAmountMatchType(filters, config)

  if (!matchType) return ''

  if (matchType === displayMatchTypes.valueInRange) {
    const minValue = isEmptyValue(filters[config.gte]) ? incompleteBoundLabel : filters[config.gte]
    const maxValue = isEmptyValue(filters[config.lte]) ? incompleteBoundLabel : filters[config.lte]

    return `${minValue} - ${maxValue}`
  }

  return `${singleValueLabelPrefixes[matchType]}${filters[getSingleValueFilterName(config, matchType)]}`
}
